import FormNuevaUnidadProductivaComponent from "../components/formsUnidad/FormNuevaUnidadProductiva";

const NuevaUnidadProductivaPage = () => {
    return(
        <div className="tic4bio-home">
            <FormNuevaUnidadProductivaComponent/>
        </div>
    );
}
export default NuevaUnidadProductivaPage;